import React from 'react';

interface Props {
  name: string;
  onBlur(routingNumber: string): void;
}

export default function USRoutingNumberField(props: Props) {
  function handleBlur(event) {
    const routingNumber = event.target.value;
    if (routingNumber.length > 0) {
      props.onBlur(routingNumber);
    }
  }

  return (
    <div>
      <input
        className="string required wide user-success"
        maxLength={9}
        type="text"
        name={props.name}
        onBlur={handleBlur}
      />
    </div>
  );
}
